export const registerCallback = (callback, argArray) => {
    setTimeout(function () {
        callback.apply(null, argArray);
    }, 0);
}

const eventHandlerContainer = {};

export const raiseEvent = (eventKey, eventArgs) => {
    var eventHanlders = eventHandlerContainer[eventKey];
    if (eventHanlders) {
        for (var i = 0; i < eventHanlders.length; i++) {
            eventHanlders[i].call(this, eventArgs);
        }
    }
};

export const registerEventHandler = (eventKey, eventFunction) => {
    var eventHanlders = eventHandlerContainer[eventKey];
    if (eventHanlders) {
        eventHanlders.push(eventFunction);
    }
    else {
        eventHandlerContainer[eventKey] = [eventFunction];
    }
};


// WEBPACK FOOTER //
// ./src/utils/callbackUtil.js